<div fxLayout="column" fxLayoutGap="8px">
  <adp-label *ngIf="preSelectedDevice != null" class="pre-header" [context]="preHeaderTextContext" [labelKey]="preHeaderTextSfKey"></adp-label>
  
  <h2 *ngIf="headerTextSfKey != null" class="header">
    <adp-label [labelKey]="headerTextSfKey"></adp-label>
  </h2>

  <adp-label *ngIf="bodyTextSfKey != null" class="body" [labelKey]="bodyTextSfKey"></adp-label>
</div>


<form [formGroup]='deviceInfoForm' (ngSubmit)="handleFormSubmitted()" class="info-form">
  <pgh-array-object-selector class="mt-40" (selectionChanged)="handleDeviceSelectionChanged($event)" (multipleObjectsDetected)="handleMultipleObjectsDetected($event)" [objects]="serialSearchResponse?.result?.value" [selectionPoints]="selectionPoints"></pgh-array-object-selector>

  <div *ngIf="deviceInfoForm.controls.selectedDevice.value != null" class="text-start">
    <adp-input class="w-100" [class.device-name-input-no-error]="deviceInfoForm.controls.nickname.valid" matInput formControlName="nickname" [resourceData]="resourceService.getResourceObject('RegisterCellularDevice_DeviceInfoForm_NicknameField')"></adp-input>
    <mat-hint class="device-name-hint"><adp-label labelKey="RegisterCellularDevice_DeviceInfoForm_NicknameField_Hint"></adp-label></mat-hint>
  </div>

  <div class="mt-32">
    <button mat-flat-button color='accent' type="submit" [disabled]='deviceInfoForm.invalid'>
      <adp-label [labelKey]="submitButtonLabelSfKey"></adp-label>
    </button>
  </div>
</form>
